import React, { useEffect } from 'react';
import styled from "@emotion/styled"

const SignupBox = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.7);
  display: ${props => props.visible ? 'block' : 'none'};
  z-index: 100000;
`

const MailerliteForm = styled.div`
  width: 800px;
  max-width: calc(100% - 40px);
  margin: 80px auto;
  padding: 40px 20px;
  position: relative;
  box-shadow: 2px 2px 6px 0 rgba(117, 176, 156, 0.3);
  background: #e5f0ed;

  @media(max-width: 600px) {
    height: 100vh;
    margin: 0;
  }

  h4 {
    line-height: 36px !important;
    margin-bottom: 30px !important;
  }

  .embedForm {
    background: none !important;
  }

  .ml-form-embedContent {
    margin: 0 !important;
  }
`

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
`

const MailerliteModal = React.memo(({ visible, onClose }) => {
  useEffect(() => {
    window.MailerLiteObject = 'ml';
    const script = document.createElement('script');
    script.async = 1;
    script.src = 'https://static.mailerlite.com/js/universal.js?v'+(~~(new Date().getTime()/1000000));
    script.onload = () => window.ml('accounts', '1382888', 'c4v2p8y4b0', 'load');
    document.head.appendChild(script);
  }, []);

  return (
    <SignupBox visible={visible}>
      <MailerliteForm>
        <CloseButton onClick={onClose}>
          X
        </CloseButton>
        <div
          className="ml-form-embed"
          data-account="1382888:c4v2p8y4b0"
          data-form="1861878:s0m6b0"
        />
      </MailerliteForm>
    </SignupBox>
  )
})

export default MailerliteModal
